module.exports = __webpack_public_path__ + "static/media/miniV5Gyro.3a199577.png";